import { Shell } from '@/components/Shell.tsx';
import type { NavItem } from '@/components/AppNav.tsx';
import {
  GridIcon,
  UsersIcon,
  UserIcon,
  ShieldIcon,
  DocIcon,
  SlidersIcon,
  BarsIcon,
  PulseIcon,
} from '@/components/ui/icons.tsx';

export function AdminShell() {
  const nav: NavItem[] = [
    { to: '/admin', label: 'Overview', end: true, icon: <GridIcon /> },
    { to: '/admin/orgs', label: 'Organisations', icon: <UsersIcon /> },
    { to: '/admin/analytics', label: 'Analytics', icon: <PulseIcon /> },
    { to: '/admin/cgc-members', label: 'CGC Members', icon: <UserIcon /> },
    { to: '/admin/admins', label: 'Admins', icon: <ShieldIcon /> },
    { to: '/admin/prompts', label: 'System Prompts', icon: <DocIcon /> },
    { to: '/admin/governance', label: 'Governance', icon: <SlidersIcon /> },
    { to: '/admin/audit-log', label: 'Audit Log', icon: <BarsIcon /> },
  ];
  return <Shell chipLabel="ADMIN" nav={nav} routeId="admin-shell" signOutPath="/admin/sign-in" />;
}
